import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureEntitlements } from './featureEntitlements'
import { FeatureToggle } from './featureToggles'

export const campaignManagementAccessControl: DomainAccessControlConfig = {}

export const pageBuilderPlacementTargetingAccessControl: DomainAccessControlConfig = {
  featureEntitlementIds: [FeatureEntitlements.PageBuilderPlacementTargeting],
  restrictedBannersAllowed: true,
}

export const placementFromCollectionAccessControl: DomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.aiCarouselCreatorM2],
  restrictedBannersAllowed: true,
}
